/* eslint-disable */
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, InjectionToken, PLATFORM_ID } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { AnalyticsServiceFactory, ANALYTICS_SERVICE_FACTORY_CONFIG } from '@rci/analytics-service';
import { AudienceManagerService } from '@rci/audience-manager-service';
import {
  EnvironmentConfig,
  EnvironmentConfigurator,
  EnvironmentLoaderService,
  EnvironmentLoaderServiceConfig,
} from '@rci/environment-loader';
import { LogService } from '@rci/log-service';
import { MiscService } from '@rci/misc-service';
import { RoutingService } from '@rci/routing-service';
import { LoginStateService, StateService } from '@rci/state-service';
import { provideLocalStorage } from '@rci/storage/local-storage.service';
import { provideSessionStorage } from '@rci/storage/session-storage.service';
import { AnalyticsService, PendingPayloadsSsrService } from '@rogers/analytics';
import { CookieService } from 'ngx-cookie-service';
import { environmentNameResolver } from './environment-name-resolver';
import { SelfServeAppInitializerService } from './lib/service/app-initializer/self-serve-app-initializer.service';

export const ENVIRONMENT_CONFIGURATOR = new InjectionToken<EnvironmentConfigurator<EnvironmentConfig>>(
  'EnvironmentConfigurator',
);

export function environmentLoaderFactory(
  envLoader: EnvironmentLoaderService<EnvironmentConfig>,
  environmentConfigurator: EnvironmentConfigurator<EnvironmentConfig>,
  logService: LogService,
) {
  return () =>
    envLoader
      .load(environmentConfigurator, error => logService.error(error), environmentNameResolver)
      .then(() => envLoader.injector.get(SelfServeAppInitializerService).bootstrap());
}

export function getCommonProviders(
  analyticsServiceFactory,
  loginStateServiceClass,
  responseInterceptorServiceClass,
  analyticsStateServiceClass,
  globalAppConfigServiceClass,
  PdoConfigServiceClass,
  environmentConfigurator,
  SemafoneConfigServiceClass,
  environmentLoaderServiceConfigFactory,
) {
  return [
    {
      provide: EnvironmentLoaderServiceConfig,
      useFactory: environmentLoaderServiceConfigFactory,
    },
    {
      provide: ENVIRONMENT_CONFIGURATOR, // this is because aot restriction
      useValue: environmentConfigurator,
    },
    Title,
    Meta,
    CookieService,
    StateService,
    provideLocalStorage(),
    provideSessionStorage(),
    {
      provide: LoginStateService,
      useClass: loginStateServiceClass,
    },
    {
      provide: AnalyticsService,
      useFactory: analyticsServiceFactory,
      deps: [
        ANALYTICS_SERVICE_FACTORY_CONFIG,
        StateService,
        analyticsStateServiceClass,
        PendingPayloadsSsrService,
        PLATFORM_ID,
      ],
    },
    AudienceManagerService.configure(),
    AudienceManagerService,
    SelfServeAppInitializerService.configure(),
    SelfServeAppInitializerService,
    MiscService.configure(),
    RoutingService.configure(),
    analyticsStateServiceClass,
    LogService,
    StateService.configure(),
    AnalyticsServiceFactory.configure(),
    globalAppConfigServiceClass.configure(),
    PdoConfigServiceClass.configure(),
    SemafoneConfigServiceClass.configure(),
    {
      provide: APP_INITIALIZER,
      // by default EnvironmentLoaderService.defaultEnvironmentNameResolver used in EnvironmentLoaderService.load()
      // but you can call 'load' method with your own implementation - envLoader.load(..., () => 'dev')
      useFactory: environmentLoaderFactory,
      deps: [EnvironmentLoaderService, ENVIRONMENT_CONFIGURATOR, LogService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: responseInterceptorServiceClass,
      multi: true,
    },
  ];
}
